import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';
import { bookingStatuses } from './grid.params';

const bookingStatusesList = Object.keys(bookingStatuses).map((fn) => ({
  name: bookingStatuses[fn],
  value: fn,
}));
// const d = moment();
const initialFlt = {
  // status: 'active',
  // ts_from: d.startOf('day').format(),
  // ts_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'start_at', title: t('grid.Начало'), change },
    { type: 'doubledate', name: 'end_at', title: t('grid.Конец'), change },
    { type: 'zones', w: 200, name: 'zone_id', title: t('grid.Зона'), change },
    {
      type: 'select',
      name: 'status',
      title: t('grid.Статус'),
      items: bookingStatusesList,
    },
    { type: 'input', name: 'vehicle_plate', title: t('sections.ГРЗ'), placeholder: t('form.А000AA 000 rus'), w: 150 },
    { type: 'input', name: 'vehicle_brand', title: t('grid.Марка авто'), placeholder: t('form.Введите текст для поиска'), w: 210 },
    { type: 'input', name: 'vehicle_model', title: t('grid.Модель авто'), placeholder: t('form.Введите текст для поиска'), w: 210 },
    { type: 'input', name: 'client_name', title: t('grid.Имя'), placeholder: t('form.Иванов Иван Иванович'), w: 200 },
    { type: 'input', w: 160, name: 'client_phone', title: t('grid.Телефон'), placeholder: t('grid.+7 (999) 999-99-99'), mask: '+9(999)9999999' },

    { type: 'input', name: 'client_email', title: t('grid.Email'), placeholder: t('form.Введите текст для поиска'), w: 210 },

    // { type: 'dict', dict: 'payment.payment_type', multiple: true },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'bookingFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
